var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title:
            _vm.$route.params.id !== "0"
              ? _vm.isDisabled
                ? "商品详情"
                : "编辑商品"
              : "添加商品",
          backUrl: "/product/list",
        },
      }),
      _vm.isCopy
        ? _c(
            "el-card",
            {
              staticClass: "mt14",
              attrs: { shadow: "never", bordered: false },
            },
            [
              _c(
                "div",
                { staticClass: "line-ht mb15" },
                [
                  _vm._v(" 生成的商品默认是没有上架的，请手动上架商品！ "),
                  _vm.copyConfig.copyType && _vm.copyConfig.copyType == 1
                    ? _c("span", [
                        _vm._v(
                          "您当前剩余" +
                            _vm._s(_vm.copyConfig.copyNum) +
                            "条采集次数。 "
                        ),
                      ])
                    : _vm._e(),
                  _vm.copyConfig.copyType && _vm.copyConfig.copyType != 1
                    ? _c(
                        "el-link",
                        {
                          attrs: {
                            type: "primary",
                            underline: false,
                            href: "https://help.crmeb.net/crmeb_java/2103903",
                            target: "_blank",
                          },
                        },
                        [_vm._v("如何配置密钥 ")]
                      )
                    : _vm._e(),
                  _c("br"),
                  _vm._v(
                    " 商品采集设置：设置 > 系统设置 > 第三方接口设置 > 采集商品配置（如配置一号通采集，请先登录一号通账号，无一号通，请选择99Api设置） "
                  ),
                ],
                1
              ),
              _vm.copyConfig.copyType && _vm.copyConfig.copyType != 1
                ? _c(
                    "div",
                    { staticClass: "mb15" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("淘宝"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("京东"),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("苏宁"),
                          ]),
                          _c("el-radio", { attrs: { label: 4 } }, [
                            _vm._v("拼多多"),
                          ]),
                          _c("el-radio", { attrs: { label: 5 } }, [
                            _vm._v("天猫"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.copyConfig.copyType
                ? _c(
                    "div",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth100",
                          attrs: {
                            placeholder: "请输入链接地址",
                            size: "small",
                          },
                          model: {
                            value: _vm.url,
                            callback: function ($$v) {
                              _vm.url =
                                typeof $$v === "string" ? $$v.trim() : $$v
                            },
                            expression: "url",
                          },
                        },
                        [
                          _c("el-button", {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "merchant:product:copy:product",
                                  "merchant:product:import:product",
                                ],
                                expression:
                                  "['merchant:product:copy:product', 'merchant:product:import:product']",
                              },
                            ],
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.addProduct },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              key: _vm.currentTab,
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "1",
                      expression: "currentTab === '1'",
                    },
                  ],
                  attrs: { gutter: 24 },
                },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品类型：", required: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "from-ipt-width el-input el-input--small",
                              attrs: { maxlength: "249", disabled: "" },
                            },
                            [
                              _c("span", { staticClass: "el-input__inner" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("productTpyeFilter")(
                                        _vm.formValidate.type
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "云盘商品、卡密商品不支持售后，一经出售，概不退换"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：", prop: "name" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "50",
                              "show-word-limit": "",
                              placeholder: "请输入商品名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商户商品分类：", prop: "cateIds" } },
                        [
                          _c("el-cascader", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              options: _vm.merProductClassify,
                              props: _vm.props2,
                              clearable: "",
                              "show-all-levels": false,
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.cateIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "cateIds", $$v)
                              },
                              expression: "formValidate.cateIds",
                            },
                          }),
                          _vm.checkPermi(["merchant:product:category:add"]) &&
                          !_vm.isDisabled
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "ml15",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAddMenu({
                                        id: 0,
                                        name: "顶层目录",
                                      })
                                    },
                                  },
                                },
                                [_vm._v("添加分类")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "平台商品分类：",
                            prop: "categoryId",
                          },
                        },
                        [
                          _c("el-cascader", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              options: _vm.productClassify,
                              props: _vm.props1,
                              filterable: "",
                              clearable: "",
                              "show-all-levels": false,
                              disabled: _vm.isDisabled,
                            },
                            on: { change: _vm.onChangeCategory },
                            model: {
                              value: _vm.formValidate.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "categoryId", $$v)
                              },
                              expression: "formValidate.categoryId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌：", prop: "brandId" } },
                        [
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "selectLoadMore",
                                  rawName: "v-selectLoadMore",
                                  value: _vm.selectLoadMore,
                                  expression: "selectLoadMore",
                                },
                              ],
                              staticClass: "from-ipt-width",
                              attrs: {
                                clearable: "",
                                filterable: "",
                                loading: _vm.loading,
                                remote: "",
                                disabled:
                                  _vm.isDisabled ||
                                  !_vm.formValidate.categoryId,
                                "remote-method": _vm.remoteMethod,
                                placeholder: "请选择品牌",
                              },
                              model: {
                                value: _vm.formValidate.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "brandId", $$v)
                                },
                                expression: "formValidate.brandId",
                              },
                            },
                            _vm._l(_vm.brandList, function (user) {
                              return _c("el-option", {
                                key: user.id,
                                attrs: { label: user.name, value: user.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位：", prop: "unitName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入单位",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.unitName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "unitName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.unitName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品让利比例：", prop: "ratio" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "from-ipt-width",
                              attrs: {
                                placeholder: "请输入商品让利比例",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.ratio,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "ratio",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formValidate.ratio",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showLockFu
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "是否锁定福豆：",
                                prop: "isLockFu",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  model: {
                                    value: _vm.formValidate.isLockFu,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formValidate,
                                        "isLockFu",
                                        $$v
                                      )
                                    },
                                    expression: "formValidate.isLockFu",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("不锁定"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("锁定"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "锁定后用户购买商品获得的部分福豆将被锁定，无法立即使用"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showLockFu && _vm.formValidate.isLockFu === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "锁仓福豆比例：",
                                prop: "lockFuRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.5表示50%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.lockFuRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "lockFuRatio",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.lockFuRatio",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "请输入 0~1 之间的数值，如 0.5 表示 50%，1 表示 100%"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商务锁仓分红：" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: { disabled: _vm.isDisabled },
                                  model: {
                                    value:
                                      _vm.formValidate.isBusinessLockDividend,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formValidate,
                                        "isBusinessLockDividend",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formValidate.isBusinessLockDividend",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("否"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("是"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v("设置后该商品将参与商务锁仓分红"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend &&
                  _vm.formValidate.isBusinessLockDividend === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商务经理分红比例：",
                                prop: "businessManagerRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.1表示10%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.businessManagerRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "businessManagerRatio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formValidate.businessManagerRatio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend &&
                  _vm.formValidate.isBusinessLockDividend === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "高级商务经理分红比例：",
                                prop: "seniorBusinessManagerRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.15表示15%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value:
                                    _vm.formValidate.seniorBusinessManagerRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "seniorBusinessManagerRatio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formValidate.seniorBusinessManagerRatio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend &&
                  _vm.formValidate.isBusinessLockDividend === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "总监分红比例：",
                                prop: "directorRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.2表示20%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.directorRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "directorRatio",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.directorRatio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend &&
                  _vm.formValidate.isBusinessLockDividend === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "高级总监分红比例：",
                                prop: "seniorDirectorRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.15表示15%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.seniorDirectorRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "seniorDirectorRatio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formValidate.seniorDirectorRatio",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showBusinessLockDividend &&
                  _vm.formValidate.isBusinessLockDividend === 1
                    ? _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "总裁分红比例：",
                                prop: "presidentRatio",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  placeholder:
                                    "请输入0~1之间的数值，如0.1表示10%",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formValidate.presidentRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "presidentRatio",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.presidentRatio",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v("5个分红比例的总和必须小于或等于1"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否拆单：", prop: "isSplit" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "from-ipt-width mr20",
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.isDisabled,
                              },
                              model: {
                                value: _vm.formValidate.isSplit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "isSplit", $$v)
                                },
                                expression: "formValidate.isSplit",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "否", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.formValidate.type == 0
                    ? _c(
                        "el-col",
                        { attrs: { xs: 18, sm: 18, md: 18, lg: 12, xl: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "运费模板：", prop: "tempId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width mr20",
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formValidate.tempId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formValidate, "tempId", $$v)
                                    },
                                    expression: "formValidate.tempId",
                                  },
                                },
                                _vm._l(_vm.shippingTemplates, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品关键字：" } },
                        [
                          _c("keyword", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              labelarr: _vm.labelarr,
                              isDisabled: _vm.isDisabled,
                            },
                            on: { getLabelarr: _vm.getLabelarr },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("用户可以根据关键字进行商品搜索"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品简介：", prop: "intro" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              type: "textarea",
                              maxlength: "100",
                              rows: 3,
                              placeholder: "请输入商品简介",
                              "show-word-limit": "",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.intro,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "intro",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.intro",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("通过公众号分享商品详情，会展示此简介信息"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品封面图：", prop: "image" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              attrs: { disabled: _vm.isDisabled },
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("1")
                                },
                              },
                            },
                            [
                              _vm.formValidate.image
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formValidate.image },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：800*800px，上传小于500kb的图片")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品轮播图：",
                            prop: "sliderImages",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _vm._l(
                                _vm.formValidate.sliderImages,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "pictrue",
                                      attrs: { draggable: "true" },
                                      on: {
                                        dragstart: function ($event) {
                                          return _vm.handleDragStart(
                                            $event,
                                            item
                                          )
                                        },
                                        dragover: function ($event) {
                                          $event.preventDefault()
                                          return _vm.handleDragOver(
                                            $event,
                                            item
                                          )
                                        },
                                        dragenter: function ($event) {
                                          return _vm.handleDragEnter(
                                            $event,
                                            item
                                          )
                                        },
                                        dragend: function ($event) {
                                          return _vm.handleDragEnd($event, item)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", { attrs: { src: item } }),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.isDisabled,
                                            expression: "!isDisabled",
                                          },
                                        ],
                                        staticClass: "el-icon-error btndel",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(index)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                              _vm.formValidate.sliderImages.length < 10 &&
                              !_vm.isDisabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "upLoadPicBox",
                                      on: {
                                        click: function ($event) {
                                          return _vm.modalPicTap("2")
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "建议尺寸：800*800px，上传小于500kb的图片；最多可上传10张图片，拖动可调整顺序"
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "保障服务：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.onchangeIsShow },
                              model: {
                                value: _vm.isShowGroup,
                                callback: function ($$v) {
                                  _vm.isShowGroup = $$v
                                },
                                expression: "isShowGroup",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: "combination" } },
                                [_vm._v("使用保障服务组合")]
                              ),
                              _c("el-radio", { attrs: { label: "alone" } }, [
                                _vm._v("单独设置保障服务"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "acea-row row-middle mb5" },
                            [
                              _c(
                                "el-select",
                                {
                                  key: _vm.multiples ? "one" : "two",
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    id: "mySelect",
                                    placeholder: "请选择保障服务",
                                    clearable: "",
                                    filterable: "",
                                    multiple: _vm.multiples,
                                    disabled: _vm.isDisabled,
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  on: { change: _vm.changeGuarantee },
                                  model: {
                                    value: _vm.formValidate.guaranteeIdsList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formValidate,
                                        "guaranteeIdsList",
                                        $$v
                                      )
                                    },
                                    expression: "formValidate.guaranteeIdsList",
                                  },
                                },
                                _vm._l(
                                  _vm.guaranteeNew,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        value: item.id,
                                        label: item.name,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(_vm.guaranteeName, function (item, index) {
                            return _c(
                              "el-tag",
                              { key: index, staticClass: "mr10" },
                              [_vm._v(_vm._s(item))]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid2, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主图视频：", prop: "video_link" } },
                        [
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    size: "small",
                                    placeholder: "请输入MP4格式的视频链接",
                                  },
                                  model: {
                                    value: _vm.videoLink,
                                    callback: function ($$v) {
                                      _vm.videoLink = $$v
                                    },
                                    expression: "videoLink",
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "refid",
                                    staticStyle: { display: "none" },
                                    attrs: { type: "file" },
                                  }),
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        slot: "append",
                                        action: "",
                                        "http-request": _vm.handleUploadForm,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        headers: _vm.myHeaders,
                                        "show-file-list": false,
                                        disabled: _vm.isDisabled,
                                        multiple: "",
                                      },
                                      slot: "append",
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: _vm.isDisabled,
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.videoLink
                                                  ? "确认添加"
                                                  : "上传视频"
                                              )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("请上传小于20M的视频"),
                          ]),
                          _vm.videoLink
                            ? _c("div", { staticClass: "iview-video-style" }, [
                                _c(
                                  "video",
                                  {
                                    staticClass: "from-ipt-width",
                                    staticStyle: {
                                      height: "100% !important",
                                      "border-radius": "10px",
                                    },
                                    attrs: {
                                      src: _vm.videoLink,
                                      controls: "controls",
                                    },
                                  },
                                  [_vm._v(" 您的浏览器不支持 video 标签。 ")]
                                ),
                                _c("div", { staticClass: "mark" }),
                                _c("i", {
                                  staticClass: "el-icon-delete iconv",
                                  on: { click: _vm.delVideo },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isShowAttr
                ? _c("creatAttr", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentTab === "2",
                        expression: "currentTab === '2'",
                      },
                    ],
                    attrs: {
                      oneFormBatch: _vm.oneFormBatch,
                      isDisabled: _vm.isDisabled,
                      formThead: _vm.formThead,
                      manyTabDate: _vm.manyTabDate,
                      ManyAttrValue: _vm.ManyAttrValue,
                      OneattrValue: _vm.OneattrValue,
                      manyTabTit: _vm.manyTabTit,
                    },
                    on: {
                      changeManyAttrValue: _vm.changeManyAttrValue,
                      handleBatchDel: _vm.handleBatchDel,
                      changeIsEditVal: _vm.changeIsEditVal,
                      changeDefault: _vm.changeDefault,
                    },
                    model: {
                      value: _vm.formValidate,
                      callback: function ($$v) {
                        _vm.formValidate = $$v
                      },
                      expression: "formValidate",
                    },
                  })
                : _vm._e(),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "3" && !_vm.isDisabled,
                      expression: "currentTab === '3' && !isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品详情：" } },
                        [
                          _c("Tinymce", {
                            key: _vm.htmlKey,
                            model: {
                              value: _vm.formValidate.content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "content",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "3" && _vm.isDisabled,
                      expression: "currentTab === '3' && isDisabled",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品详情：" } }, [
                        _c("div", {
                          staticClass: "contentPic",
                          domProps: {
                            innerHTML: _vm._s(_vm.formValidate.content || "无"),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab === "4",
                      expression: "currentTab === '4'",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联表单：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            disabled: _vm.isDisabled,
                            placeholder: "请选择关联表单",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.formValidate.systemFormId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formValidate, "systemFormId", $$v)
                            },
                            expression: "formValidate.systemFormId",
                          },
                        },
                        _vm._l(_vm.systemFormList, function (item, index) {
                          return _c("el-option", {
                            key: index.id,
                            attrs: { value: item.id, label: item.formName },
                          })
                        }),
                        1
                      ),
                      _vm.checkPermi(["merchant:system:form:add"]) &&
                      !_vm.isDisabled
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ml15",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handlerCreatFrom(0, "add")
                                },
                              },
                            },
                            [_vm._v("添加表单")]
                          )
                        : _vm._e(),
                      _vm.checkPermi(["merchant:system:form:add"]) &&
                      !_vm.isDisabled
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ml15",
                              attrs: { size: "small" },
                              on: { click: _vm.getSystemFormList },
                            },
                            [_vm._v("刷新")]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "from-tips mb5" }, [
                        _vm._v(
                          " 用户购买此商品时，必须填写关联表单中设置的字段内容才能够进行订单支付，例如：部分商品购买必须填写身份证号、预约时间等 "
                        ),
                      ]),
                      _c("div", { staticClass: "from-tips mb15 colorPrompt" }, [
                        _vm._v(
                          "注：关联系统表单之后，该商品则不可进行「加入购物车」操作"
                        ),
                      ]),
                      _vm.formValidate.systemFormId
                        ? _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "acea-row row-middle" }, [
                              _c("div", [
                                _c("iframe", {
                                  staticStyle: {
                                    width: "350px",
                                    height: "500px",
                                  },
                                  attrs: {
                                    src:
                                      _vm.$selfUtil.getFrontDomainUrl() +
                                      "/pages/goods/systemIframe/index?id=" +
                                      _vm.formValidate.systemFormId,
                                    frameborder: "0",
                                  },
                                }),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.formValidate.type == 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "用户申请退款：" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              disabled: _vm.isDisabled,
                              "active-value": true,
                              "inactive-value": false,
                              "active-text": "开启",
                              "inactive-text": "关闭",
                              width: 35,
                            },
                            model: {
                              value: _vm.formValidate.refundSwitch,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "refundSwitch", $$v)
                              },
                              expression: "formValidate.refundSwitch",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "开启之后用户可进行退款申请；关闭之后仅支持商家直接退款，用户不能申请退款"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formValidate.type == 0
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "配送方式：",
                            prop: "deliveryMethodList",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { disabled: _vm.isDisabled },
                              model: {
                                value: _vm.formValidate.deliveryMethodList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "deliveryMethodList",
                                    $$v
                                  )
                                },
                                expression: "formValidate.deliveryMethodList",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: "1" } }, [
                                _vm._v("商家配送"),
                              ]),
                              _c("el-checkbox", { attrs: { label: "2" } }, [
                                _vm._v("到店自提"),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "from-tips mb5" }, [
                            _vm._v(
                              " 请先配置店铺地址之后，再开启到店自提；若店铺统一关闭到店自提功能，商品配送方式选中到店自提，用户购买不支持到店自提！ "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "from-tips mb5 colorPrompt" },
                            [
                              _vm._v(
                                "注：店铺统一关闭到店自提功能，该商品必须选中「商家配送」"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序：" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max: 9999,
                          placeholder: "请输入排序",
                          disabled: _vm.isDisabled,
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            return _vm.proving1($event)
                          },
                        },
                        model: {
                          value: _vm.formValidate.sort,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formValidate,
                              "sort",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "formValidate.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isShowInStreet
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "店铺街排序：" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 9999,
                              placeholder: "0-9999，数值越大越靠前",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.streetSort,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "streetSort", $$v)
                              },
                              expression: "formValidate.streetSort",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v("数值越大，在店铺街中排序越靠前"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "proCoupon",
                          attrs: { label: "赠送优惠券：" },
                        },
                        [
                          _c("div", { staticClass: "from-tips mb14" }, [
                            _vm._v("用户购买商品后赠送的优惠券"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "acea-row" },
                            [
                              _vm._l(
                                _vm.formValidate.coupons,
                                function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      staticClass: "mr10 mb10",
                                      attrs: {
                                        closable: !_vm.isDisabled,
                                        "disable-transitions": false,
                                      },
                                      on: {
                                        close: function ($event) {
                                          return _vm.handleCloseCoupon(tag)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(tag.name) + " ")]
                                  )
                                }
                              ),
                              _vm.formValidate.couponIds == null
                                ? _c("span", { staticClass: "mr15" }, [
                                    _vm._v("无"),
                                  ])
                                : _vm._e(),
                              !_vm.isDisabled
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "mr15",
                                      attrs: { size: "small" },
                                      on: { click: _vm.addCoupon },
                                    },
                                    [_vm._v("选择优惠券")]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitUp },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < 4,
                          expression: "Number(currentTab) < 4",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _vm.checkPermi(["merchant:product:update"])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === "3" ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab === '3' || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _vm.checkPermi(["merchant:product:update"])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.isDisabled &&
                                this.productSwitch &&
                                ((_vm.$route.params.id > 0 &&
                                  this.formValidate.auditStatus > 0) ||
                                  _vm.$route.params.id == 0),
                              expression:
                                "\n            !isDisabled &&\n            this.productSwitch &&\n            (($route.params.id > 0 && this.formValidate.auditStatus > 0) || $route.params.id == 0)\n          ",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmitAndAudit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存并提审")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-bottom",
          attrs: {
            title: "创建商品分类",
            visible: _vm.editDialogConfig.visible,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "540px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _vm.editDialogConfig.visible
            ? _c("edit", {
                attrs: {
                  prent: _vm.editDialogConfig.prent,
                  "is-create": _vm.editDialogConfig.isCreate,
                  "edit-data": _vm.editDialogConfig.data,
                  biztype: _vm.editDialogConfig.biztype,
                  "all-tree-list": _vm.merProductClassify,
                },
                on: { hideEditDialog: _vm.hideEditDialog },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }